import Route from 'cio/routes/base';

export default class ResetPasswordNewPasswordRedirectRoute extends Route {
  redirect(_model, transition) {
    this.router.replaceWith('reset_password.new_password', {
      queryParams: {
        resetPasswordToken: transition.to.queryParams.reset_password_token,
      },
    });
  }
}
